import React, { useState } from 'react';
import { I18n } from 'react-redux-i18n';
import styled from 'styled-components';
import { CheckCircleOutlined } from '@ant-design/icons';

import Button from 'components/Button';
import Cell from 'components/Cell';
import Table from 'components/Table';
import Header from 'components/Table/Header';

const Container = styled.div`
  .showAllContainer {
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    width: 200px;
  }
`;

const SumariesSubmissions = ({ wines, data, retractedSize = 10 }) => {
  const [showAll, setShowAll] = useState(false);

  const getColumns = () => {
    let columns = [
      {
        Header: () => (
          <Header
            styles={`justify-content:flex-start;padding-left:30px`}
            title={I18n.t('negoce.submissionsRecap.columns.negociant')}
          />
        ),
        Cell: (props) => (
          <Cell
            {...props}
            font="sfcompact_text"
            styles={`justify-content:flex-start;padding-left:30px;font-weight: 600;`}
          />
        ),
        minWidth: 230,
        accessor: 'negociant',
        name: I18n.t('negoce.submissionsRecap.columns.negociant')
      }
    ];

    wines.forEach((wine) => {
      const winesNegocie = data.filter((negoce) => !!negoce[wine.wine_name]);
      columns.push({
        Header: () => (
          <Header title={wine.wine_name + ` (${winesNegocie.length})`} />
        ),
        Cell: (props) => (
          <Cell
            {...props}
            value={
              props.value ? (
                <CheckCircleOutlined style={{ fontSize: 20 }} />
              ) : (
                ' '
              )
            }
            font="sfcompact_text"
          />
        ),
        width: 300,
        accessor: wine.wine_name
      });
    });

    return columns.filter((item) => item !== false);
  };

  let columns = getColumns();
  const subData = showAll ? data : data.slice(0, retractedSize);

  return (
    <Container>
      <Table columns={columns} data={subData} />
      <div className="showAllContainer ignored-export">
        {!showAll && data.length > retractedSize && (
          <Button
            width="200px"
            label={` ${I18n.t('travel.seeMoreTable')} (+${
              data.length - retractedSize
            })`}
            color="white"
            textColor="black"
            textTransform="normal"
            border="0.8px black solid"
            fontFamily="SFCompactText"
            fontSize="12px !important"
            onClick={() => setShowAll(true)}
          />
        )}
        {showAll && data.length > retractedSize && (
          <Button
            width="200px"
            label={I18n.t('travel.seeLess')}
            color="white"
            textColor="black"
            textTransform="normal"
            border="0.8px black solid"
            fontFamily="SFCompactText"
            fontSize="12px !important"
            onClick={() => setShowAll(false)}
          />
        )}
      </div>
    </Container>
  );
};

export default SumariesSubmissions;
